import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {HelmetProvider} from 'react-helmet-async';
import {initTheme} from '@/hooks/useThemeMode';
import App from './App';
import '@/styles/fonts.css';
import '@/styles/globals.css';

// Initialize theme before rendering to avoid FOUC
initTheme();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App/>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
